"use strict";
/**
 * StandOut WordPress Theme
 * Template-specific functionality initialization
 * Uses body classes to determine current template
 *
 * @package StandOut
 * @since 2.0.0
 */
// Button animations (GSAP entrance — loads on all pages)
import("./button-animations").catch((error) => {
    console.error("Failed to load button animations module:", error);
});
// Hero Home
const heroHome = document.getElementsByClassName("header--hero-home");
if (heroHome.length > 0) {
    import("./blocks/hero-home").catch((error) => {
        console.error("Failed to load hero-home module:", error);
    });
}
// Nuvra Logo Header
const nuvraLogoHeader = document.getElementsByClassName("header--nuvra-logo-header");
if (nuvraLogoHeader.length > 0) {
    import("./blocks/nuvra-logo-header").catch((error) => {
        console.error("Failed to load nuvra-logo-header module:", error);
    });
}
// Title Header
const titleHeader = document.getElementsByClassName("header--title-header");
if (titleHeader.length > 0) {
    import("./blocks/title-header").catch((error) => {
        console.error("Failed to load title-header module:", error);
    });
}
// Vertical Scroll Slider
const verticalScrollSlider = document.getElementsByClassName("flexible--vertical-scroll-slider");
if (verticalScrollSlider.length > 0) {
    import("./blocks/vertical-scroll-slider").catch((error) => {
        console.error("Failed to load vertical-scroll-slider module:", error);
    });
}
// CTA
const cta = document.getElementsByClassName("flexible--cta");
if (cta.length > 0) {
    import("./blocks/cta").catch((error) => {
        console.error("Failed to load cta module:", error);
    });
}
// Background Quote
const backgroundQuote = document.getElementsByClassName("flexible--background-quote");
if (backgroundQuote.length > 0) {
    import("./blocks/background-quote").catch((error) => {
        console.error("Failed to load background-quote module:", error);
    });
}
// Product Categories List
const productCategoriesList = document.getElementsByClassName("flexible--product-categories-list");
if (productCategoriesList.length > 0) {
    import("./blocks/product-categories-list").catch((error) => {
        console.error("Failed to load product-categories-list module:", error);
    });
}
// Innovation Highlight
const innovationHighlight = document.getElementsByClassName("flexible--innovation-highlight");
if (innovationHighlight.length > 0) {
    import("./blocks/innovation-highlight").catch((error) => {
        console.error("Failed to load innovation-highlight module:", error);
    });
}
// Img With Text
const imgWithText = document.getElementsByClassName("flexible--img-with-text");
if (imgWithText.length > 0) {
    import("./blocks/img-with-text").catch((error) => {
        console.error("Failed to load img-with-text module:", error);
    });
}
// Sector Slider
const sectorSlider = document.getElementsByClassName("flexible--sector-slider");
if (sectorSlider.length > 0) {
    import("./blocks/sector-slider").catch((error) => {
        console.error("Failed to load sector-slider module:", error);
    });
}
// Product Categories Grid
const productCategoriesGrid = document.getElementsByClassName("product-categories-grid");
if (productCategoriesGrid.length > 0) {
    import("./blocks/product-categories-grid").catch((error) => {
        console.error("Failed to load product-categories-grid module:", error);
    });
}
// Steps Slider
const stepsSlider = document.getElementsByClassName("flexible--steps-slider");
if (stepsSlider.length > 0) {
    import("./blocks/steps-slider").catch((error) => {
        console.error("Failed to load steps-slider module:", error);
    });
}
// Core Values
const coreValues = document.getElementsByClassName("flexible--core-values");
if (coreValues.length > 0) {
    import("./blocks/core-values").catch((error) => {
        console.error("Failed to load core-values module:", error);
    });
}
// Contact Form
const contactForm = document.getElementsByClassName("flexible--contact-form");
if (contactForm.length > 0) {
    import("./blocks/contact-form").catch((error) => {
        console.error("Failed to load contact-form module:", error);
    });
}
// Product Detail
const productDetail = document.getElementsByClassName("single-product");
if (productDetail.length > 0) {
    import("./blocks/product-detail").catch((error) => {
        console.error("Failed to load product-detail module:", error);
    });
}
// Ecommerce Events (GA4 select_item on lister pages)
const gaSelectItems = document.querySelector("[data-ga-item]");
if (gaSelectItems) {
    import("./blocks/ecommerce-events").catch((error) => {
        console.error("Failed to load ecommerce-events module:", error);
    });
}
// Footer
const footer = document.getElementsByClassName("footer");
if (footer.length > 0) {
    import("./footer").catch((error) => {
        console.error("Failed to load footer module:", error);
    });
}
// Default page template
const page = document.getElementsByClassName("page-template-default");
if (page.length > 0) {
    import("./page").catch((error) => {
        console.error("Failed to load page template module:", error);
    });
}
